// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"92883f29","511":"1fccc14a","598":"5f587eaa","787":"161252e7"}[chunkId] + ".chunk.js";
};